import CryptoJS from 'crypto-js'
export default function setUserSign (url, data) {
  const timestamp = new Date().getTime()
  // const shallowHeader = Object.assign({}, headers)
  // 为什么要进行浅拷贝，保证每一次重新发起请求headers配置都是新的，不保留上一次请求的headers配置信息
  let hash = CryptoJS.HmacSHA256(`${url}?json=${JSON.stringify(data)}&t=${timestamp}`, 'JfIR9RofenbQoTO')
  let hashInBase64 = CryptoJS.enc.Base64.stringify(hash)
  return hashInBase64 + timestamp
}
